module.exports = __webpack_public_path__ + "img/borescope_protoype2 copy.d72a2d17.jpg";